<template>
  <div id="homePage" :class="{ 'dark-mode': isDarkMode }">
    <component :is="currentView" :goBack="goBack" @changeView="handleChangeView" @toggleDarkMode="updateDarkMode" :showSiteList="showSiteList"></component>

    <nav class="bottom-nav" :class="{ 'dark-mode': isDarkMode }">
<!--      <button-->
<!--        @click="changeView('Home')"-->
<!--        :class="{ active: currentView === 'Home' }"-->
<!--        class="home-button"-->
<!--      >-->
<!--        <img :src="currentView === 'Home' ? (isDarkMode ? homepn1 : shome) : (isDarkMode ? homepn : ichomeActive)" alt="Home" />-->
<!--        <span>Home</span>-->
<!--      </button>-->
<!--      <button-->
<!--        @click="changeView('SitePage')"-->
<!--        :class="{ active: currentView === 'SitePage' }"-->
<!--        class="home-button"-->
<!--      >-->
<!--        <img :src="currentView === 'SitePage' ? (isDarkMode ? sitepn1 : sanalytics) : (isDarkMode ? sitepn : analyticsActive)" alt="Site" />-->
<!--        <span>Site</span>-->
<!--      </button>-->

      <button
        v-if="showTradeTab"
        @click="changeView('BuySell')"
        :class="{ active: currentView === 'BuySell' }"
        class="home-button"
      >
        <img :src="currentView === 'BuySell' ? (isDarkMode ? tradepn1 : strade) : (isDarkMode ? tradepn : tradeActive)" alt="Trade" />
        <span>Trade</span>
      </button>
<!--      <button-->
<!--      <button-->
<!--        v-if="showTradeTab"-->
<!--        @click="changeView('BuySellWallet')"-->
<!--        :class="{ active: currentView === 'BuySell' }"-->
<!--        class="home-button"-->
<!--      >-->
<!--        <img :src="currentView === 'BuySell' ? (isDarkMode ? tradepn1 : strade) : (isDarkMode ? tradepn : tradeActive)" alt="Trade" />-->
<!--        <span>Trade</span>-->
<!--      </button>-->
<!--      <button-->
<!--        @click="changeView('Alerts')"-->
<!--        :class="{ active: currentView === 'Alerts' }"-->
<!--        class="home-button"-->
<!--      >-->
<!--        <img :src="currentView === 'Alerts' ? (isDarkMode ? alertpn1 : snotification) : (isDarkMode ? alertpn : alertsActive)" alt="Alerts" />-->
<!--        <span>Alerts</span>-->
<!--      </button>-->

      <button
        @click="changeView('Settings')"
        :class="{ active: currentView === 'Settings' }"
        class="home-button"
      >
        <img :src="currentView === 'Settings' ? (isDarkMode ? settingpn1 : ssettings) : (isDarkMode ? settingpn : settingsActive)" alt="Settings" />
        <span>Settings</span>
      </button>
    </nav>
  </div>
</template>

<script>
import { useRoute, useRouter } from 'vue-router';

import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import Home from "../views/Home.vue";
import SitePage from "./SitePage.vue";
import Alerts from "../views/Alert.vue";
import Settings from "../views/Settings.vue";
import BuySell from "../views/BuySell.vue";
import SiteList from "../components/SiteList.vue";
import TradeService from "@/services/trade.service";
import UserService from "@/services/user.service";

import ichomeActive from "../../images/home.svg";
import shome from "../../images/shome.svg";
import analyticsActive from "../../images/analytics.svg";
import sanalytics from "../../images/sanalytics.svg";
import tradeActive from "../../images/trade.png";
import strade from "../../images/strade.svg";
import alertsActive from "../../images/alerts.svg";
import snotification from "../../images/snotification.svg";
import settingsActive from "../../images/settings.svg";
import ssettings from "../../images/ssettings.svg";
import homepn from "../../public/darkThemeImage/homepn.svg";
import homepn1 from "../../public/darkThemeImage/homepn1.svg";
import sitepn from "../../public/darkThemeImage/sitepn.svg";
import sitepn1 from "../../public/darkThemeImage/sitepn1.svg";
import tradepn from "../../public/darkThemeImage/tradepn.svg";
import tradepn1 from "../../public/darkThemeImage/tradepn1.svg";
import alertpn from "../../public/darkThemeImage/alertpn.svg";
import alertpn1 from "../../public/darkThemeImage/alertpn1.svg";
import settingpn from "../../public/darkThemeImage/setpn.svg";
import settingpn1 from "../../public/darkThemeImage/setpn1.svg";


export default {
  components: {
    Home,
    SitePage,
    Alerts,
    Settings,
    BuySell,
    SiteList,
  },
  setup(props, { emit }) {
    const store = useStore();
    const currentView = ref("BuySell");
    const history = ref([]);
    const showTradeTab = ref(false);
    const isDarkMode = ref(false);
    const route = useRoute();
    const router = useRouter();
    const showSiteList = ref(false);

    const changeView = (view) => {
      let wallet = false;
      if(view === 'BuySellWallet'){
      view = 'BuySell';
      wallet = true;
         router.push('/wallet');
      }
      if (currentView.value !== "BuySell") {
        history.value.push(currentView.value);
      } else if(!wallet) {
        router.push('/homepage');
      }
      currentView.value = view;
      showSiteList.value = false;
      emit("updateView", view);
    };

    const goBack = () => {
      if (history.value.length > 0) {
        const lastView = history.value.pop();
        currentView.value = lastView;
      } else {
        currentView.value = "BuySell";
      }
    };

    const handleChangeView = (view) => {
      console.log("view", view);
      changeView(view);
    };

    const updateDarkMode = (newVal) => {
      isDarkMode.value = newVal;
      document.body.classList.toggle('dark-mode', newVal);
    };

    onMounted(async () => {
      const savedDarkMode = localStorage.getItem('darkMode');

      if (savedDarkMode === 'true') {
        isDarkMode.value = true;
        document.body.classList.add('dark-mode');
      }
      // showTradeTab.value = await TradeService.hasPeerToPeerEnabled();
      showTradeTab.value = true;
      if (route.query.view === 'SitePage' && route.query.component === 'SiteList') {
        showSiteList.value = true;
        currentView.value = 'SitePage';
      } else if (route.query.view) {
        changeView(route.query.view);
      }
    });

    return {
      currentView,
      showTradeTab,
      changeView,
      goBack,
      ichomeActive,
      shome,
      analyticsActive,
      sanalytics,
      tradeActive,
      strade,
      alertsActive,
      snotification,
      settingsActive,
      ssettings,
      homepn,
      homepn1,
      sitepn,
      sitepn1,
      tradepn,
      tradepn1,
      alertpn,
      alertpn1,
      settingpn,
      settingpn1,
      handleChangeView,
      isDarkMode,
      updateDarkMode,
      showSiteList,
    };
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap");

#homePage {
  padding-bottom: calc(52px + env(safe-area-inset-bottom));
}

.bottom-nav {
  display: flex;
  justify-content: space-around;
  padding: 7px 0;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
  z-index: 99999;
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  padding-bottom: env(safe-area-inset-bottom);
}



button {
  background: none;
  border: none;
  color: #453a94;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

button.active {
  color: #8d7efd;
}

.home-button img {
  width: 24px;
  height: 24px;
  margin-bottom: 5px;
}

button span {
  font-size: 10px;
  font-family: "Inter", sans-serif;
  font-weight: 400;
}
</style>
